import { render } from "./Login.vue?vue&type=template&id=922a228a&scoped=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=922a228a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-922a228a"

export default script